import WebLayout from "../../components/WebLayout";
import Landing from "../../components/landing/Landing";
import WorkList from "./workList/WorkList";
import { baseUrl, getService } from "../../utils/apiData";
import axios from "axios";
import Loader from "../../components/loader/Loader.jsx";
import { Fragment, useEffect, useState } from "react";

const Services = () => {
  const [loader, setLoader] = useState(false);
  const [services, setServices] = useState([]);

  const getServicesApi = async () => {
    setLoader(true);
    try {
      const res = await axios.get(`${baseUrl}/${getService}`);

      if (res?.data?.success) {
        setServices(res?.data?.data?.mainservice);
      }
    } catch (error) {
      console.log(error);
    }
    setLoader(false);
  };

  useEffect(() => {
    getServicesApi();
  }, []);

  return (
    <WebLayout>
      {loader ? (
        <Loader />
      ) : (
        <Fragment>
          <Landing title="Our Services" from="Home" page="Services" />
          <WorkList dataList={services} />
        </Fragment>
      )}
    </WebLayout>
  );
};

export default Services;


